import { NRLogger as o } from "./contact-channels40.js";
const n = async (t, s, r) => {
  const e = await fetch(
    `https://c2c-service.care.vpsvc.com/v1/countries/tenants/${t}/locales/${s}/segments/${r}?requestor=ContactChannelsLib`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
  if (!e.ok)
    throw o.error("Contact Channels: Available Countries", {
      status: e.status,
      message: "Failed to fetch Available Countries from C2C Service"
    }), new Error(`HTTP error! Status: ${e.status}`);
  return e.json();
};
export {
  n as getAvailableCountries
};
//# sourceMappingURL=contact-channels59.js.map
